module.exports = __webpack_public_path__ + "img/lightBrown.544402c2.svg";